import { AttackStatus } from '../attack-status'

export enum SyslogAttackStatus {
  EXPLOITED = 'EXPLOITED',
  SUSPICIOUS = 'SUSPICIOUS',
  BLOCKED = 'BLOCKED',
  BLOCKED_PERIMETER = 'BLOCKED_PERIMETER',
  PROBED = 'PROBED'
}

export const getAttackStatusFromSyslogAttackStatus = {
  [SyslogAttackStatus.EXPLOITED]: AttackStatus.EXPLOITED,
  [SyslogAttackStatus.SUSPICIOUS]: AttackStatus.SUSPICIOUS,
  [SyslogAttackStatus.BLOCKED]: AttackStatus.BLOCKED,
  [SyslogAttackStatus.BLOCKED_PERIMETER]: AttackStatus.BLOCKED_PERIMETER,
  [SyslogAttackStatus.PROBED]: AttackStatus.PROBED
}
